var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rb"},[_c('div',{ref:"Rmain",staticClass:"Rmain",style:({ width: '480px', height: '280px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }